var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44336 9.14209C3.44336 8.17559 4.22686 7.39209 5.19336 7.39209H51.86C52.8265 7.39209 53.61 8.17559 53.61 9.14209C53.61 10.1086 52.8265 10.8921 51.86 10.8921H5.19336C4.22686 10.8921 3.44336 10.1086 3.44336 9.14209Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44336 27.8088C3.44336 26.8423 4.22686 26.0588 5.19336 26.0588H18.0267C18.9932 26.0588 19.7767 26.8423 19.7767 27.8088C19.7767 28.7753 18.9932 29.5588 18.0267 29.5588H5.19336C4.22686 29.5588 3.44336 28.7753 3.44336 27.8088Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44336 46.4754C3.44336 45.5089 4.22686 44.7254 5.19336 44.7254H18.0267C18.9932 44.7254 19.7767 45.5089 19.7767 46.4754C19.7767 47.4419 18.9932 48.2254 18.0267 48.2254H5.19336C4.22686 48.2254 3.44336 47.4419 3.44336 46.4754Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.61 30.7254C25.61 24.2821 30.8334 19.0588 37.2767 19.0588C43.72 19.0588 48.9434 24.2821 48.9434 30.7254C48.9434 37.1687 43.72 42.3921 37.2767 42.3921C30.8334 42.3921 25.61 37.1687 25.61 30.7254ZM37.2767 22.5588C32.7664 22.5588 29.11 26.2151 29.11 30.7254C29.11 35.2357 32.7664 38.8921 37.2767 38.8921C41.787 38.8921 45.4434 35.2357 45.4434 30.7254C45.4434 26.2151 41.787 22.5588 37.2767 22.5588Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4604 37.0669C43.1462 36.3859 44.2543 36.3899 44.9352 37.0758L53.1019 45.3014C53.7829 45.9872 53.7789 47.0953 53.093 47.7762C52.4071 48.4572 51.2991 48.4532 50.6182 47.7673L42.4515 39.5417C41.7705 38.8559 41.7745 37.7478 42.4604 37.0669Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFind);
export default __webpack_public_path__ + "static/media/find.d3ff93dc.svg";
export { ForwardRef as ReactComponent };